import React, {
   forwardRef,
   useEffect,
   useImperativeHandle,
   useRef,
   useState,
} from "react";
import "./Container.css";

const DISPLACEMENT_FACTOR = 40;

const BgFragment = forwardRef(({ icon, posX: _posX, posY: _posY, color: _color }, ref) => {
   const [client_screenwidth, setClientScreenwidth] = useState(0);
   const [displacementX, setDisplacementX] = useState(0);
   const [displacementY, setDisplacementY] = useState(0);
   const [posX, setPosX] = useState(_posX);
   const [posY, setPosY] = useState(_posY);
   const [color, setColor] = useState(_color);
   const [opacity, setOpacity] = useState();
   const fragment_ref = useRef();

   useImperativeHandle(ref, () => ({
      resetFragment(posX, posY) {
         setPosX(posX);
         setPosY(posY);
         setDisplacementX(0);
         setDisplacementY(0);
      },
      changeFragmentColor(color) {
         setColor(color)
      },
      changeOpacity(opacity) {
         setOpacity(opacity)
      },

   }));

   useEffect(() => {
      setClientScreenwidth(window.innerWidth);
   }, []);

   const fixPositionX = () => (posX + displacementX) % client_screenwidth;
   const fixPositionY = () => posY + displacementY;

   const calculateDisplacement = (e) => {
      const { top, left, bottom, right, width, height } =
         fragment_ref.current.getBoundingClientRect();
      const centerX = (left + right) / 2;
      const centerY = (top + bottom) / 2;
      const [abs_x, abs_y] = [e.clientX, e.clientY];
      const displacement_ratio_x = (2 * (centerX - abs_x)) / width;
      const displacement_ratio_y = (2 * (centerY - abs_y)) / height;
      return [displacement_ratio_x, displacement_ratio_y];
   };

   function handleMouseEnter(e) {
      const [displacement_ratio_x, displacement_ratio_y] =
         calculateDisplacement(e);
      setDisplacementX(
         (prev) =>
            (prev + DISPLACEMENT_FACTOR * displacement_ratio_x) %
            client_screenwidth
      );

      setDisplacementY(
         (prev) => prev + DISPLACEMENT_FACTOR * displacement_ratio_y
      );

   }
   function isActive(){
      return posX >= 0 && posY >= 0
   }
   const ModifiedIcon = React.cloneElement(icon, {...icon.props, color, });

   return (
      isActive() && <span
         ref={fragment_ref}
         className="fragment"
         onMouseEnter={handleMouseEnter}
         style={{
            left: fixPositionX(),
            top: fixPositionY(),
            color: color,
            opacity
         }}
      >
         {ModifiedIcon}
      </span>
   );
});
export default BgFragment;
